module.exports = __webpack_public_path__ + "img/swiper1.77e61349.jpg";